import React, { useEffect, createElement } from 'react';
import AdvertorialGlpAdv6 from '../components/AdvertorialGlpAdv6';
import { HelmetProvider, Helmet } from 'react-helmet-async';
// Declare fbq for TypeScript
declare global {
  interface Window {
    fbq: any;
  }
}
export function GlpAdv6Page() {
  useEffect(() => {
    // Initialize Facebook Pixel with safety checks
    !function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      // Safety check: if no script elements exist, append to head instead
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    // Initialize with your NEW Pixel ID for Adv6
    window.fbq('init', '9567705179928833');
    window.fbq('track', 'PageView');
    // Track ViewContent for this advertorial
    window.fbq('track', 'ViewContent', {
      content_name: 'Ozempic Depression Investigation',
      content_category: 'Health',
      content_type: 'article'
    });
    // Store fbclid in localStorage if present in URL
    const params = new URLSearchParams(window.location.search);
    const fbclid = params.get('fbclid');
    if (fbclid) {
      localStorage.setItem('fbclid', fbclid);
    }
    // Set up scroll depth tracking - NEW CUSTOM EVENTS
    let tracked50 = false;
    let tracked90 = false;
    const handleScroll = () => {
      const scrollPercent = window.scrollY / (document.body.scrollHeight - window.innerHeight) * 100;
      if (!tracked50 && scrollPercent > 50) {
        window.fbq('trackCustom', 'Advertorial_Scroll_50');
        tracked50 = true;
      }
      if (!tracked90 && scrollPercent > 90) {
        window.fbq('trackCustom', 'Advertorial_Scroll_90');
        tracked90 = true;
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return <HelmetProvider data-id="element-18532" data-mp="2tyytxo2e5owg">
      <div className="w-full min-h-screen bg-gray-100" data-id="element-18533" data-mp="2u2momqjkohcr">
        <Helmet data-id="element-18534" data-mp="2g8llzlpi2a74">
          <title data-id="element-18535" data-mp="2g82fr297pa8x">
            Endocrinologist Investigates: Why Are 1 in 10 Ozempic Users
            Experiencing Severe Depression—And Why Isn't Anyone Talking About
            It?
          </title>
          <meta property="og:title" content="Endocrinologist Investigates: Why Are 1 in 10 Ozempic Users Experiencing Severe Depression—And Why Isn't Anyone Talking About It?" data-id="element-18536" data-mp="26d0re8mrgc7e" />
          <meta property="og:description" content="After three decades in endocrinology, I've prescribed thousands of medications. But when patients on Ozempic started reporting severe depression—and regulatory agencies ignored it—I spent 16 months and my own money investigating." data-id="element-18537" data-mp="1xbu7rqotel9x" />
          <meta property="og:type" content="article" data-id="element-18538" data-mp="1dpiy5oa177yy" />
          <meta property="og:url" content={window.location.href} data-id="element-18539" data-mp="1dr2c3887t6xk" />
          <meta property="og:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/rj5HPkWXSP8komhpUDQJCG/6OUBdNn4rvjDcxkk8ToP9.jpg" data-id="element-18540" data-mp="1rq21ii3jxpus" />
          <meta property="og:image:width" content="1200" data-id="element-18541" data-mp="21mokf1cbi6u6" />
          <meta property="og:image:height" content="630" data-id="element-18542" data-mp="21l3r1f1qotxw" />
          <meta property="og:site_name" content="Health Investigation Series" data-id="element-18543" data-mp="1wo3ld58sxt7b" />
          <meta name="twitter:card" content="summary_large_image" data-id="element-18544" data-mp="2bchtnvozm9v9" />
          <meta name="twitter:title" content="Endocrinologist Investigates: Why Are 1 in 10 Ozempic Users Experiencing Severe Depression—And Why Isn't Anyone Talking About It?" data-id="element-18545" data-mp="2bbok6myn969f" />
          <meta name="twitter:description" content="After three decades in endocrinology, I've prescribed thousands of medications. But when patients on Ozempic started reporting severe depression—and regulatory agencies ignored it—I spent 16 months and my own money investigating." data-id="element-18546" data-mp="2kdxx1jhdxbpz" />
          <meta name="twitter:url" content={window.location.href} data-id="element-18547" data-mp="imys34t1t9di" />
          <meta name="twitter:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/rj5HPkWXSP8komhpUDQJCG/6OUBdNn4rvjDcxkk8ToP9.jpg" data-id="element-18548" data-mp="neyz1h7jd2jl" />
        </Helmet>
        <AdvertorialGlpAdv6 data-id="element-18549" data-mp="rfitgd0q5s21" />
      </div>
    </HelmetProvider>;
}